import React from 'react';
import { CustomColumn, StringColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';

import ApproveCell from './ApproveCell';

export const COL_NAMES = {
	kycName: 'fullName',
	bankName: 'validatedAccountHolderName',
	accountNumber: 'maskedAccountNumber',
	documentType: 'documentType',
	status: 'status',
	rejectedAt: 'timestamp',
	kycId: '_id',
	uid: 'uid'
};

// No user column: the tab is already scoped to the selected user.
export const columnConfigs = [
	// The two names sit adjacent on purpose: the whole point of this screen is comparing them.
	StringColumn({
		title: 'KYC Name',
		mapDataToValue: (data: any) => data[COL_NAMES.kycName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Bank Account Name',
		mapDataToValue: (data: any) => data[COL_NAMES.bankName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Bank A/C',
		maxWidth: 140,
		mapDataToValue: (data: any) => data[COL_NAMES.accountNumber] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Document',
		maxWidth: 120,
		mapDataToValue: (data: any) => data[COL_NAMES.documentType] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Rejected At',
		minWidth: 200,
		maxWidth: 200,
		columnName: COL_NAMES.rejectedAt
	}),
	StringColumn({
		title: 'Status',
		maxWidth: 120,
		mapDataToValue: (data: any) => data[COL_NAMES.status] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Action',
		maxWidth: 200,
		mapDataToValue: (data: any) => ({
			kycId: data[COL_NAMES.kycId],
			uid: data[COL_NAMES.uid],
			status: data[COL_NAMES.status],
			kycName: data[COL_NAMES.kycName],
			bankName: data[COL_NAMES.bankName]
		}),
		renderCell: (params: any) => {
			const { value } = params;
			return (
				<ApproveCell
					kycId={value?.kycId}
					uid={value?.uid}
					status={value?.status}
					kycName={value?.kycName}
					bankName={value?.bankName}
				/>
			);
		}
	})
];
